/* eslint-disable react/prop-types */
import classes from "./home.module.scss";
import Flex from "@/components-library/layout/flex";
import ComposedViewOne from "@/composed-views/composed-view-one";
import ComposedViewFour from "@/composed-views/composed-view-four";
import SplashBanner from "./spash-banner";
import ComposedViewInfiniteCarousel from "@/composed-views/composed-view-infinite-carousel";
import listsFile from "@/static-texts/lists.json";
import CardSliderPartner from "@/composed-views/card-slider-partner";
import ComposedViewFive from "@/composed-views/composed-view-five";

function Home({ onFindOutClick, content }) {
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 768px)").matches;

  const { partners } = listsFile;
  return (
    <Flex
      align="flex-start"
      className={classes.home}
      direction="column"
      justify="flex-start"
    >
      <SplashBanner home={content} onFindOutClick={onFindOutClick} />

      <ComposedViewFour
        title={content.pmi.title}
        content={content.pmi.content}
        hyperLinks={content.pmi.hyperLinks}
        image={content.pmi.image}
        button={content.pmi.button}
      />

      <ComposedViewOne
        title={content.reports.title}
        content={content.reports.content}
        image={content.reports.image}
        button={content.reports.button}
        reverse={isMobile}
      />

      <ComposedViewFive
        title={content.help.title}
        content={content.help.content}
        button={content.help.button}
        className={classes.help}
      />

      <ComposedViewInfiniteCarousel
        items={partners}
        title={content.partners.title}
        itemType={<CardSliderPartner />}
      />

      <Flex justify="center" align="center" className={classes.regionLogo}>
        <a
          href="https://prossimiti-bucket-public.s3.eu-south-1.amazonaws.com/region_logo.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={"/region-logo.png"} alt="Logo" />
        </a>
      </Flex>
    </Flex>
  );
}

export default Home;
